import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { TOP_PROGRESS_BAR_TEST_ID } from './const';

type TopProgressBarProps = {
	progress: number;
	className?: string;
};

const TopProgressBar: FC<TopProgressBarProps> = ({ progress, className }) => {
	const componentClasses = classNames(classes.topProgressBar, className);

	const style = useMemo(
		() => ({
			width: `${progress}%`,
		}),
		[progress],
	);

	return (
		<div className={componentClasses}>
			<div
				style={style}
				className={classes.topProgressBar__progress}
				data-testid={TOP_PROGRESS_BAR_TEST_ID}
				data-progress={progress}
			/>
		</div>
	);
};

export { TopProgressBar };
